module.exports = __webpack_public_path__ + "static/media/inbox.e444f36f.svg";